import { Button } from "../Button";
import { Container } from "../Container";

import "../../styles/hero.css";
import { siteSettings } from "../../settings";
import backgroundImage from "../../images/background-image.png";

export function Hero() {
  return (
    <div 
      className="relative overflow-hidden"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingTop: '120px' // Add padding to account for the absolutely positioned header
      }}
    >
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      
      <Container className="relative z-10 pb-60 pt-20 text-center lg:pt-32">
        <h1 className="mx-auto max-w-4xl font-sans text-4xl font-semibold tracking-tight text-white sm:text-7xl hero_text ">
          <span> {""} BitBloFin</span>
          <span> {""} -</span>
          <span> {""} Where</span>
          <span> {""} Whales</span>
          <span> {""} are Made </span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-[18px] tracking-tight text-[#CECFD1] hero_support">
          Seamlessly merging complexity with ease, {siteSettings.name} offers
          top-notch security, 24/7 support, and an intuitive platform for your
          trading needs.
        </p>
        <div className="mt-10 flex justify-center gap-x-6 hero_buttons">
          <Button href={`${siteSettings.appLink}/register`}>Get started</Button>
          <Button href={`${siteSettings.appLink}/login`} variant="outline">
            <span>Log in</span>
          </Button>
        </div>
      </Container>
    </div>
  );
}

// import Image from 'next/image
// import logoLaravel from '@/images/logos/laravel.svg'
// import logoMirage from '@/images/logos/mirage.svg'
// import logoStatamic from '@/images/logos/statamic.svg'
// import logoStaticKit from '@/images/logos/statickit.svg'
// import logoTransistor from '@/images/logos/transistor.svg'
// import logoTuple from '@/images/logos/tuple.svg'
